import { forwardRef, useEffect, useState } from 'react';
type Item = { id: string; label: string };
const SectionNav = forwardRef<HTMLElement, { items: Item[]; label: string; className?: string }>(
  function SectionNav({ items, label, className = 'section-nav' }, ref) {
    const [active, setActive] = useState(items[0]?.id);
    useEffect(() => {
      let frame = 0;
      const update = () => {
        frame = 0;
        const headings = items.map(item => ({ id: item.id, element: document.getElementById(item.id) })).filter(item => item.element);
        const reached = headings.filter(item => item.element!.getBoundingClientRect().top <= 160);
        setActive((reached[reached.length - 1] || headings[0])?.id);
      };
      const scroll = () => { if (!frame) frame = requestAnimationFrame(update); };
      update(); window.addEventListener('scroll', scroll, { passive: true });
      return () => { window.removeEventListener('scroll', scroll); cancelAnimationFrame(frame); };
    }, [items]);
    return <nav ref={ref} className={className} aria-label={label}>{items.map(item => <a key={item.id} href={`#${item.id}`} aria-current={active === item.id ? 'location' : undefined} onClick={() => setActive(item.id)}>{item.label}</a>)}</nav>;
  }
);
export default SectionNav;
